import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const userBankSelector = ({ userBank }: ReducerState) => userBank;
export const userBankLoadingSelector = createSelector(
  userBankSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
